export const serviceBranchConnectionDisagrees = (serviceBranchConnection, connectionPoint) => {
    return (serviceBranchConnection && connectionPoint && serviceBranchConnection !== connectionPoint)
}

export const connectionTypeDisagrees = (connectionType, serviceMain) => {
    return (connectionType && serviceMain && connectionType !== serviceMain)
}

/**
 * 
 * @param {string} fuseRating E.g. "100 Amp" or "Other"
 * @param {number|undefined} fuseRatingOther 
 * @param {number|undefined} networkApprovedFuseRating 
 * @returns 
 */
export const fuseRatingDisagrees = (fuseRating, fuseRatingOther, networkApprovedFuseRating) => {
    // console.log('fuseRatingDisagrees started')
    let fuseRatingNumber = (fuseRating === 'Other') ? fuseRatingOther : fuseRating.replace(/[ ]*Amp/, '')
    fuseRatingNumber = fuseRatingNumber * 1
    // console.log('fuseRatingDisagrees fuseRatingNumber, networkApprovedFuseRating', fuseRatingNumber, networkApprovedFuseRating)
    const isWithinTolerance = withinTolerance(networkApprovedFuseRating, fuseRatingNumber, 0.2)
    // console.log('fuseRatingDisagrees isWithinTolerance', isWithinTolerance ? 'true' : 'false')
    return (fuseRatingNumber > 0 && networkApprovedFuseRating > 0 && !isWithinTolerance)
}

/**
 * 
 * @param {string[]} phaseList E.g. ['White', 'Red']
 * @param {string[]} networkApprovedPhaseList E.g. ["Red","White"]
 * @returns 
 */
export const phaseListDisagrees = (phaseList, networkApprovedPhaseList) => {
    return (phaseList.length > 0 && networkApprovedPhaseList.length > 0 && !phasesMatch(phaseList, networkApprovedPhaseList))
}

/**
 * 
 * @param {string} rippleControllerPhase E.g. '' or 'Red' or 'Not Installed'
 * @param {boolean|null} rippleControllerRequired
 * @returns true if rippleControllRequired is identically false and rippleControllerPhase is not 'Not Installed' or
 *               if rippleControllRequired is identically true  and rippleControllerPhase is     'Not Installed'
 */
export const rippleControllerPhaseDisagrees = (rippleControllerPhase, rippleControllerRequired) => {
    return (
        rippleControllerPhase
        &&
        (
            (rippleControllerRequired === false && rippleControllerPhase !== 'Not Installed')
            ||
            (rippleControllerRequired === true && rippleControllerPhase === 'Not Installed')
        )
    )
}

/**
 * 
 * @param {boolean|null} isRippleControlRequired 
 * @returns {string} ripple controller recommendation or empty string if parameter is null.
 */
export function rippleControllerRecommends(isRippleControlRequired) {
    return (
        isRippleControlRequired === true
        ?
        'Red, White, Blue or Not Traceable'
        :
        (
            isRippleControlRequired === false
            ?
            'Not Installed'
            :
            ''
        )
    )
}


/**
 * 
 * @param {object} phaseList e.g. ['White','Red']
 * @param {string} networkApprovedPhaseList e.g. ['Red', 'White']
 * @returns {boolean} true if the phases in each list are the same.
 */
function phasesMatch(phaseList, networkApprovedPhaseList) {
    const sortedNetworkApprovedPhaseList = networkApprovedPhaseList.sort()
    const stringifiedNetworkApprovedPhaseList = JSON.stringify(sortedNetworkApprovedPhaseList)
    const sortedPhaseList = phaseList.sort()
    const stringifiedPhaseList = JSON.stringify(sortedPhaseList)
    return stringifiedNetworkApprovedPhaseList === stringifiedPhaseList
}

/**
 * 
 * @param {number} numberA 
 * @param {number} numberB 
 * @param {number} tolerance between 0 and 1
 * @returns {boolean} true if numberB is within tolerance of numberA.
 */
function withinTolerance(numberA, numberB, tolerance) {
    // console.log('withinTolerance numberA, numberB, tolerance', numberA, numberB, tolerance)
    if (isNaN(numberA) || isNaN(numberB) || isNaN(tolerance)) {
        return false
    }
    if (0 > tolerance || tolerance > 1) {
        return false
    }
    const toleranceAmount = numberA * tolerance
    return (numberB >= (numberA - toleranceAmount) && numberB <= (numberA + toleranceAmount))
}